import { useQueryParams } from 'use-query-params'
import { useCallback, useMemo } from 'react'

import { queryToTableSearchAdapter, tableSearchToQueryAdapter } from './utils'

import type { TableSearch } from '@app/hooks/useTableSearch/types'
import type { DecodedValueMap, QueryParamConfigMap } from 'use-query-params'
import type { TableSearchQuerySchema, UseTableSearchQueryReturn } from './types'

export const useTableSearchQuery = <ColumnsType>(
  tableSearchQuerySchema: TableSearchQuerySchema<ColumnsType>
): UseTableSearchQueryReturn<ColumnsType> => {
  const [tableSearchQuery, setTableSearchQuery] = useQueryParams(
    tableSearchQuerySchema as DecodedValueMap<QueryParamConfigMap>
  )

  const tableSearchFromQuery = useMemo(
    () => queryToTableSearchAdapter<ColumnsType>(tableSearchQuery),
    [tableSearchQuery]
  )

  const updateTableSearchQuery = useCallback(
    (newTableSearch: TableSearch<ColumnsType>): void => {
      const newTableSearchQuery = tableSearchToQueryAdapter(newTableSearch, tableSearchQuerySchema)
      setTableSearchQuery(newTableSearchQuery)
    },
    [tableSearchQuerySchema]
  )

  return {
    tableSearchFromQuery,
    updateTableSearchQuery
  }
}
